import { routesApi } from '../store/api/routesApi';
import type { AppDispatch } from '../store';
import {
  buildCargoAllocationIndex,
  type CargoAllocationCore,
  type RouteAllocationsBundle,
} from './applicationCargoAllocationStats';

/** @deprecated CARGO-L3 — use CargoLifecycleProjectionClient when REACT_APP_CARGO_LIFECYCLE_PROJECTION_UI=true. */
/** Единая цепочка: заявки → маршруты → getAllocations → buildCargoAllocationIndex (legacy). */
export async function fetchCargoAllocationIndexForApplications(
  dispatch: AppDispatch,
  applicationIds: number[]
): Promise<Map<number, CargoAllocationCore>> {
  const appIds = Array.from(
    new Set(
      applicationIds
        .map((n) => Number(n))
        .filter((n) => Number.isFinite(n) && n > 0)
    )
  );
  if (appIds.length === 0) {
    return new Map();
  }

  const routeLists = await Promise.all(
    appIds.map((appId) =>
      dispatch(routesApi.endpoints.getRoutesByApplication.initiate(appId)).unwrap()
    )
  );

  const routeIdSet = new Set<number>();
  for (const list of routeLists) {
    for (const r of list || []) {
      const id = Number((r as { id?: number }).id);
      if (Number.isFinite(id) && id > 0) routeIdSet.add(id);
    }
  }

  const routeIds = Array.from(routeIdSet);
  if (routeIds.length === 0) {
    return new Map();
  }

  const routeResults: RouteAllocationsBundle[] = await Promise.all(
    routeIds.map(async (routeId) => {
      const rows = await dispatch(routesApi.endpoints.getAllocations.initiate(routeId)).unwrap();
      return { routeId, allocations: Array.isArray(rows) ? rows : [] };
    })
  );

  return buildCargoAllocationIndex(routeResults);
}
